module.exports = __webpack_public_path__ + "img/carrousel-rad-conv-8.60b1343e.png";